import { render, staticRenderFns } from "./event.html?vue&type=template&id=363e08ad&scoped=true&"
import script from "./event.js?vue&type=script&lang=js&"
export * from "./event.js?vue&type=script&lang=js&"
import style0 from "./event.css?vue&type=style&index=0&id=363e08ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e08ad",
  null
  
)

export default component.exports